import type { GQL_ID } from '@@partner:types:graphql'
import type { RsuiteItemDataType } from '@@partner:types:app'

import React, { useCallback, useState, useEffect } from 'react'
import { useFetchAllMarketingLabels } from '@@partner:graphql/query/labels/allMarketingLabels.gql'

import { Button, Modal, ButtonGroup, TagPicker } from 'rsuite'

export interface ProductCategoriesPickerModalProps {
  value: GQL_ID[]
  open: boolean
  onChange: (selectedIds: GQL_ID[]) => void
  onClose: () => void
}

export default function LabelsPickerModal ({
  value,
  onChange,
  onClose,
  open = false
}: ProductCategoriesPickerModalProps) {
  const [ state, setState ] = useState<GQL_ID[]>(value || [])
  const [ page ] = useState(1)
  const { data } = useFetchAllMarketingLabels({
    pager: { page }
  })

  const allLabels = data?.allMarketingLabels?.edges.map((item: any) => ({
    label: item?.name ? item.name : item.system_name,
    value: item?.id
  })) ?? []

  useEffect(() => {
    setState(value)
  }, [ value ])

  const handleLabelsIdsChange = useCallback((newState: GQL_ID[]) => {
    setState(newState)
  }, [])

  const handleSaveChosenCategories = useCallback(() => {
    onChange(state)
    onClose()
  }, [ onChange, state, onClose ])

  const handleCloseModal = useCallback(() => {
    setState(value)
    onClose()
  }, [ value, onClose ])

  return (
    <Modal open={open} onClose={handleCloseModal}>
      <Modal.Header>Привязать лейблы к товару</Modal.Header>
      <Modal.Body>
        <TagPicker
          value={state}
          onChange={handleLabelsIdsChange}
          style={{ minWidth: 200 }}
          data={allLabels}
          placeholder="Лейблы"
          size="sm"
        />

        <ButtonGroup justified>
          <Button onClick={handleCloseModal}>Отмена</Button>
          <Button
            onClick={handleSaveChosenCategories}
            color="green"
            appearance="primary"
          >
            OK
          </Button>
        </ButtonGroup>
      </Modal.Body>
    </Modal>
  )
}
